// Opening a show used to copy the shown-cues list (layers.showCues) over the shown-layers
// list (layers.viewing), so Hide Cues then a refresh hid the whole layer (Josh, staging QA,
// 23 Oct 2026). The shown-layers list is now filled in from shown cues only when it was
// never saved; a saved list, even an empty one, is left alone.

export function viewingToSeedOnOpen(layers) {
    if (!layers || Array.isArray(layers.viewing)) return null;
    return Array.isArray(layers.showCues) ? layers.showCues : null;
}
export default viewingToSeedOnOpen;


// WEBPACK FOOTER //
// ./src/lib/layer-visibility-on-open.js